import LogoVipDe from '../src/LogoVipDe';
export default LogoVipDe;
